import React from 'react';
import { Grid } from '@material-ui/core';
import { SkeletonCardGridProps } from './SkeletonUtils';
import SkeletonContributorCard from './SkeletonContributorCard';
import SkeletonChannelCard from './SkeletonChannelCard';
import SkeletonArticleCard from './SkeletonArticleCard';

export const SkeletonCardGridGenerator = (props: SkeletonCardGridProps) => {
	const { generatedItemsLength: length, containerProps, itemProps, cardType = 'channel' } = props;

	const items = Array.from({ length }, () => Math.floor(Math.random() * 9));

	const children = () => {
		if (cardType === 'contributor') return <SkeletonContributorCard />;
		if (cardType === 'article') return <SkeletonArticleCard />;
		return <SkeletonChannelCard />;
	}

	if (!children()) return <></>;

	return (
		<Grid container {...containerProps}>
			{items.map((_, key) => (
				<Grid item key={key} {...itemProps}>
					{children()}
				</Grid>
			))}
		</Grid>
	);
};

export default SkeletonCardGridGenerator;
